'use client'

import { useEffect } from 'react'

export default function SetHtmlAttrs({
  lang,
  dir,
}: {
  lang: string
  dir: 'ltr' | 'rtl'
}) {
  useEffect(() => {
    document.documentElement.lang = lang
    document.documentElement.dir = dir
    document.body.className = `${lang === 'fa' ? 'font-farsi' : lang === 'ar' ? 'font-arabic' : 'font-sans'} text-white antialiased overflow-x-hidden ${dir === 'rtl' ? 'rtl' : ''}`
  }, [lang, dir])
  return null
}